import { getDistanceFromLatLonInKm } from './geoUtils';

/**
 * Filters a list of vacancies based on active filter criteria and optionally by distance.
 *
 * @param {Array} vacancies - The list of vacancies to filter
 * @param {Object} filters - The currently selected filter values
 * @param {{ lat: number, lon: number } | null} userLocation - The geocoded coordinates of the user (based on postcode)
 * @returns {Array} The filtered list of vacancies
 */
export function filterVacancies(vacancies, filters, userLocation) {
    return vacancies.filter((vacancy) => {
        const matchesFilters =
            (filters.disciplines.length === 0 || filters.disciplines.some(d => (vacancy.disciplines || []).includes(d))) &&
            (filters.brands.length === 0 || filters.brands.some(b => (vacancy.brands || []).includes(b))) &&
            (filters.locations.length === 0 || filters.locations.includes(vacancy.location)) &&
            (filters.working_hours.length === 0 || filters.working_hours.some(hour =>
                hour >= vacancy.working_hours_min && hour <= vacancy.working_hours_max
            )) &&
            (filters.experiences.length === 0 || filters.experiences.some(experience =>
                (vacancy.experience || 0) >= experience
            ));

        // If the vacancy does not match the filters, exclude it
        if (!matchesFilters) return false;

        // If user location and radius filter are provided, apply distance filtering
        if (userLocation && filters.distance.radius) {
            if (!vacancy.latitude || !vacancy.longitude) return false;
            const distance = getDistanceFromLatLonInKm(
                userLocation.lat,
                userLocation.lon,
                vacancy.latitude,
                vacancy.longitude
            );

            // Include only if within selected radius
            return distance <= parseFloat(filters.distance.radius);
        }

        // No distance filtering applied, include the vacancy
        return true;
    });
}
